/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object,
    shape,
    arrayOf,
    string,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
    container: {
        fontFamily: 'Roboto, serif',
        lineHeight: '20px',
        borderTop: `${theme.palette.desktopHeaderMenu.border}`,
        fontSize: '14px',
        textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
        letterSpacing: '0.03em',
        textRendering: 'optimizeLegibility',
        margin: '0 15px',
        maxWidth: '1400px',
        minWidth: '1000px',
        [theme.breakpoints.up(1430)]: {
            margin: '0 auto',
        },
    },
    heading: {
        fontSize: '24px',
        textAlign: 'center',
        width: '100%',
        margin: '16px 0',
    },
    content: {
        margin: '16px auto',
        textAlign: 'center',
        '& h4': {
            margin: '16px 0',
            textAlign: 'center',
            width: '100%',
            fontSize: '20px',
            fontWeight: '500',
        },
        '& p': {
            fontSize: '14px',
            textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
            letterSpacing: '0.03em',
            textRendering: 'optimizeLegibility',
            whiteSpace: 'pre-wrap',
        },
        '& a': {
            color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
            cursor: 'pointer',
            textDecoration: 'underline',
            marginRight: '-4px',
        },
    },
    articleWrapper: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        boxWizing: 'border-box',
        alignContent: 'space-between',
    },
    articleContainer: {
        padding: '8px',
        flexGrow: '1',
        maxWidth: '100%',
        flexBasis: '0',
        '& a': {
            color: `${theme.palette.common.black}`,
            cursor: 'pointer',
            textDecoration: 'none',
            marginRight: '0',
            userSelect: 'none',
            textAlign: 'center',
        },
    },
    articleImageContainer: {
        display: 'flex',
        position: 'relative',
        minWidth: '1px',
        minHeight: '1px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    articleHeading: {
        marginTop: '8px',
        display: 'block',
        whiteSpace: 'pre-wrap',
        fontSize: '14px',
        textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
        letterSpacing: '0.03em',
        textRendering: 'optimizeLegibility',
    },
});

const SympathyCremationFactsBlock = (props) => {
    const {
        data: {
            heading,
            banner_url,
            multi_description,
            // related_articles,
        },
        classes,
    } = props;

    const seed = useUIDSeed();

    const mapMultiDescription = (item) => {
        if (item.strong && item.content) {
            return (
                <p key={seed(item)}>
                    <strong>{item.strong}</strong>{item.content}
                </p>
            );
        }
        if (item.image_url) {
            return (
                <div className={classes.content} key={seed(item)}>
                    <img className={classes.bannerImg} src={item.image_url} alt="Sympathy Banner" />
                </div>
            );
        }
        if (item.content1 && item.link_content) {
            return (
                <p key={seed(item)}>
                    {item.content1} <Link to={item.link_url}>{item.link_content}</Link> {item.content2}
                </p>
            );
        }
        if (item.strong && item.list) {
            return (
                <div key={seed(item)}>
                    <strong>{item.strong}</strong>
                    <ul>
                        {item.list.map((link) => (<li key={seed(link)}><a href={link.link_url}>{link.link_content}</a></li>))}
                    </ul>
                </div>
            );
        }
        return (
            <p key={seed(item)}>
                {item.content}
            </p>
        );
    };
    const related_articles = null;

    return (
        <>
            <div className={classes.container}>
                <div className={classes.heading}>{heading}</div>
                <div className={classes.content}>
                    <img className={classes.bannerImg} src={`${banner_url}?width=1094`} alt="Sympathy Banner" />
                </div>
                <div className={classes.content}>
                    {multi_description && multi_description.length > 0 && multi_description.map((item) => mapMultiDescription(item, classes))}
                </div>
                <div className={classes.content}>
                    <h4>{related_articles && related_articles.heading}</h4>
                    <div className={classes.articleWrapper}>
                        {
                            related_articles && related_articles.articles && related_articles.articles.map((item) => {
                                const {
                                    link, image_url, title,
                                } = item;
                                return (
                                    <div className={classes.articleContainer} key={seed(item)}>
                                        <Link to={link}>
                                            <div className={classes.articleImageContainer}>
                                                <img className={classes.bannerImg} src={image_url} alt={title} />
                                            </div>
                                            <span className={classes.articleHeading}>{title}</span>
                                        </Link>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

SympathyCremationFactsBlock.propTypes = {
    classes: object.isRequired,
    data: shape({
        heading: string.isRequired,
        banner_url: string.isRequired,
        multi_description: arrayOf(
            shape({
                content: string,
            }),
        ),
        related_articles: shape({
            heading: string.isRequired,
            articles: arrayOf(
                shape({
                    link: string.isRequired,
                    image_url: string.isRequired,
                    title: string.isRequired,
                }),
            ),
        }),
    }).isRequired,
};
export default withStyles(styles)(SympathyCremationFactsBlock);
